import BlainBaseService from "./BlainBaseService";
import { IBannerXAd } from "JS/sponsored/sponsored-types";
import { IHeaderJson } from "../types/Header";

export class GlobalResourceService extends BlainBaseService {

	public async getHeaderData(): Promise<IHeaderJson> {
		const res = await this._httpSvc.get<IHeaderJson>(`/globalresource/header/`);
		return res;
	}

	public async getCategoryFlyoutAd(): Promise<IBannerXAd> {
		const res = await this._httpSvc.get<IBannerXAd>('/globalresource/category-flyout/');
		return res;
	}

}

export default new GlobalResourceService();